module.exports = __webpack_public_path__ + "static/fk-159f2b5c07681108b5a709ba83089080.png";